import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import URLSearchParams from 'url-search-params';
import { nbsApiOneClickSignup } from '../../../store/actions/oneClickSignup';
import { nbsApiOneClickLogin } from '../../../store/actions/oneClickLogin';
import { setSessionToken } from '../../../store/actions/session';
import OneClick from '../../../components/Auth/OneClick/OneClick';
import paths from '../../../constants/paths';
import config from '../../../constants/config';
import { getRomanceGuardParam } from '../../../assets/helpers/utils';

class OneClickContainerContainer extends Component {
  state = { isChecked: true, isGDPR: false, showError: false, errorMessage: '' };

  componentDidUpdate (prevProps) {
    if (this.props.myLocation.status === 'success' &&
      this.props.myLocation.response &&
      this.props.myLocation.response.country &&
      this.props.myLocation.status !== prevProps.myLocation.status
    ) {
      const { country } = this.props.myLocation.response;
      if (this._checkIfConsentRequired()) {
        this.setState({ isGDPR: true });
      }
    }

    if (this.props.oneClickSignup.status === 'success' && this.props.oneClickSignup.status !== prevProps.oneClickSignup.status) {
      this.loginUser(this.props.oneClickSignup.response.force_login.force_login_token);
    } else if (this.props.oneClickSignup.status === 'fail' && this.props.oneClickSignup.status !== prevProps.oneClickSignup.status) {
      this.toggleAlertError(this.props.oneClickSignup.error.error);
    }

    if (this.props.oneClickLogin.status === 'success' && this.props.oneClickLogin.status !== prevProps.oneClickLogin.status) {
      this.props.setSessionToken(this.props.oneClickLogin.response.token);
    } else if (this.props.oneClickLogin.status === 'fail' && this.props.oneClickLogin.status !== prevProps.oneClickLogin.status) {
      this.toggleAlertError(this.props.oneClickLogin.error.error);
    }
  }

  toggleAlertError = (msg = '') => {
    this.setState({ showError: !this.state.showError, errorMessage: msg });
  }

  toggleCheckBox = () => {
    this.setState({ isChecked: !this.state.isChecked });
  }

  registerUser = () => {
    const query = new URLSearchParams(this.props.history.location.search);
    const obj = {
      signup_type: 'oneclick_coreg',
      oneclick: query.get('oneclick'),
      platform: 'web',
      __RG: getRomanceGuardParam(),
      language: this.props.language.code
    };
    // console.log('REGISTER:::', obj);
    this.props.nbsApiOneClickSignup(obj);
  }

  loginUser = (token) => {
    const obj = {
      login_type: 'login_token',
      device_type: 3,
      platform: 'web',
      force_login_token: token,
      __RG: getRomanceGuardParam()
    };

    // console.log('LOGIN::::', obj);
    this.props.nbsApiOneClickLogin(obj);
  }

  goToSignup = () => {
    this.props.history.replace(paths.SIGNUP);
  }

  _checkIfConsentRequired = () => {
    const { getConfig } = this.props;
    return (
      getConfig.response &&
      getConfig.response.show_cookie_consent
    );
  };

  render () {
    // console.log('ONECLICKCONTAINER RENDER:::', this.props, this.state);
    return (
      <OneClick
        {...this.state}
        toggleCheckBox={this.toggleCheckBox}
        toggleAlertError={this.toggleAlertError}
        registerUser={this.registerUser}
        goToSignup={this.goToSignup}
        showSpinner={this.props.oneClickSignup.isFetching || this.props.oneClickLogin.isFetching}
        isLandscape={this.props.isLandscape}
      />
    );
  }
}

function mapStateToProps (state) {
  return {
    myLocation: state.myLocation,
    getConfig: state.getConfig,
    oneClickSignup: state.oneClickSignup,
    oneClickLogin: state.oneClickLogin,
    language: state.language
  };
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    nbsApiOneClickSignup,
    nbsApiOneClickLogin,
    setSessionToken
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OneClickContainerContainer);
